import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import PauseScene from '../scenes/PauseScene';

export default class Hud extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene) {
    super(scene);

    this.setup();
  }

  setup () {
    this.scene.add.zone(0,0,this.scene.scale.width, this.scene.scale.height).setOrigin(0)
      .setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleArrowClick, this)
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.handleArrowRelease, this);

    this.bgContainer = this.scene.add.container();
    this.add(this.bgContainer);
    this.bg = ABCyaPhaser.Images.addImage(0,0, 'UI_Header', this.bgContainer).setOrigin(0);
    this.txtScore = this.scene.add.bitmapText(this.bg.width / 2, this.bg.height / 2 - 7, 'scoreFont', '0', 62, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5);
    this.bgContainer.add(this.txtScore);

    this.curScore = 0;

    this.btnMenu = ABCyaPhaser.Images.addImage(0,0, 'BUTTON_menu', this.bgContainer).setInteractive()
      .on(
        Phaser.Input.Events.GAMEOBJECT_POINTER_UP,
        () => {this.scene.scene.run(PauseScene.KEY, { pausedScene: this.scene.scene });}
        , this
      );

    this.btnAudio = ABCyaPhaser.Images.addImage(0,0, 'BUTTON_volume', this.bgContainer).setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onAudioClick, this);

    this.btnMenu.x = this.btnMenu.width / 2 + 50;
    this.btnAudio.x = this.scene.scale.width - this.btnAudio.width / 2 - 50;
    this.btnMenu.y = this.bg.height / 2 - 6;
    this.btnAudio.y = this.btnMenu.y;

    this.bgContainer.add([this.btnMenu, this.btnAudio]);

    const ismuted = this.scene.sound.mute;
    if (ismuted) {
      this.btnAudio.setFrame('BUTTON_mute');
    }
    else {
      this.btnAudio.setFrame('BUTTON_volume');
    }

    this.flashOverlay = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0x2c5d5d).setOrigin(0);
    this.add(this.flashOverlay);
    this.flashOverlay.alpha = 1;

    this.scoreState = null;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this));
  }

  addToScore(value) {
    this.curScore += value;
    this.txtScore.text = this.curScore;
  }

  addToFinalScore(value) {
    this.curScore += value;
    this.txtFinalScore.text = this.curScore;
  }

  onAudioClick() {
    const ismuted = !this.scene.sound.mute;
    this.scene.sound.mute = ismuted;

    if (ismuted) {
      this.btnAudio.setFrame('BUTTON_mute');
    }
    else {
      this.btnAudio.setFrame('BUTTON_volume');
    }
  }

  showGameOver(objectCounts) {
    this.objectCounts = objectCounts;
    this.bcount = 0;
    this.gcount = 0;
    this.hcount = 0;
    this.moveTo(this.flashOverlay, 0);
    ABCyaPhaser.Tweens.addTween(this.flashOverlay, 480, { alpha: 0.8 }, Phaser.Math.Easing.Quadratic.Out);

    this.menuBgContainer = this.scene.add.container(0,-800);
    this.add(this.menuBgContainer);

    this.menuBg = ABCyaPhaser.Images.addImage(0,0, 'ScoreBg', this.menuBgContainer).setOrigin(0);
    this.menuText = this.scene.add.bitmapText(35, this.menuBg.height / 2 , 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('your_score'), 66);
    const bounds = this.menuText.getTextBounds();
    this.txtFinalScore = this.scene.add.bitmapText(this.menuText.x + bounds.local.width,this.menuBg.height / 2, 'scoreFont',this.curScore.toString(), 74);
    this.txtFinalScore.y = this.menuBg.height / 2 - this.txtFinalScore.height / 2 - 3;
    this.menuText.y = this.menuBg.height / 2 - this.txtFinalScore.height / 2 - 12;
    this.menuBgContainer.add(this.txtFinalScore);
    this.menuBgContainer.add(this.menuText);

    this.txtBrushes = this.scene.add.bitmapText(-330,0, 'choiceFont','b X 0', 62);
    this.txtBrushes.y = this.menuBg.height * 2 + 33;
    this.txtHats = this.scene.add.bitmapText(-330,0, 'choiceFont','h X 0', 62);
    this.txtHats.y = this.txtBrushes.y + this.txtBrushes.height + 13;
    this.txtGlasses = this.scene.add.bitmapText(-330,0, 'choiceFont','g X 0', 62);
    this.txtGlasses.y = this.txtHats.y + this.txtHats.height + 13;
    this.add([this.txtBrushes, this.txtHats, this.txtGlasses]);

    ABCyaPhaser.Tweens.addTween(this.bgContainer, 740, { y: this.bg.height * -1 }, Phaser.Math.Easing.Quadratic.In);
    ABCyaPhaser.Tweens.addTween(this.menuBgContainer, 1740, { delay: 600, y: this.menuBg.height, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out, () => this.beginObjectCounting());

    this.btnPlayAgain = this.scene.add.container(this.scene.scale.width / 2, this.scene.scale.height * 0.75);
    ABCyaPhaser.Buttons.addSimpleButton(0,0, 'BUTTON_quit', 'BUTTON_quitDWN', () => this.handlePlayAgain(), this.btnPlayAgain, { pressAnimationConfig: null, releaseAnimationConfig: null });

    const btnPlayAgainTxt = this.scene.add.bitmapText(0,0, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.play_again'), 48, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
      .setTintFill(0xefa02e);
    this.btnPlayAgain.add(btnPlayAgainTxt);
    ABCyaPhaser.Text.resizeFontToFitWidth(btnPlayAgainTxt, 115, 125);

    this.btnPlayAgain.setScale(0);
    this.showGo();
  }

  beginObjectCounting() {
    ABCyaPhaser.Tweens.addTween(this.txtBrushes, 600, { x: this.scene.scale.width * 0.5 - this.txtBrushes.width * 0.5, easeParams: [0.1, 0.4] },Phaser.Math.Easing.Elastic.Out, () => {
      this.scoreState = 1;
    });
  }

  beginHatCounting() {
    ABCyaPhaser.Tweens.addTween(this.txtHats, 600, { x: this.scene.scale.width * 0.5 - this.txtHats.width * 0.5, easeParams: [0.1, 0.4] },Phaser.Math.Easing.Elastic.Out, () => {
      this.scoreState = 2;
    });
  }

  beginGlassesCounting() {
    ABCyaPhaser.Tweens.addTween(this.txtGlasses, 600, { x: this.scene.scale.width * 0.5 - this.txtGlasses.width * 0.5, easeParams: [0.1, 0.4] },Phaser.Math.Easing.Elastic.Out, () => {
      this.scoreState = 3;
    });
  }

  showGo() {
    ABCyaPhaser.Tweens.addTween(this.btnPlayAgain, 800, { delay: 1740, scale: 1, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);
  }

  handlePlayAgain() {
    this.emit('START_OVER');
  }

  handleArrowClick(pointer) {
    const clickValue = pointer.x < this.scene.scale.width * 0.5 ? -1 : 1;
    this.emit('ARROW_CLICKED', clickValue);
  }

  handleArrowRelease() {
    this.emit('ARROW_CLICKED', 0);
  }

  flashScreen() {
    this.flashOverlay.alpha = 1;
    ABCyaPhaser.Tweens.addTween(this.flashOverlay, 480, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
  }

  update () {
    if (this.scoreState === null) return;
    if (this.scoreState === 1) {
      if (this.objectCounts.brushes > 0) {
        this.bcount++;
        this.addToFinalScore(10);
        this.objectCounts.brushes--;

        this.txtBrushes.text = `b X ${this.bcount}`;
      }
      else {
        this.scoreState = null;
        this.beginHatCounting();
      }
    }
    else if (this.scoreState === 2) {
      if (this.objectCounts.hats > 0) {
        this.hcount++;
        this.addToFinalScore(10);
        this.objectCounts.hats--;

        this.txtHats.text = `h X ${this.hcount}`;
      }
      else {
        this.scoreState = null;
        this.beginGlassesCounting();
      }
    }
    else if (this.scoreState === 3) {
      if (this.objectCounts.glasses > 0) {
        this.gcount++;
        this.addToFinalScore(10);
        this.objectCounts.glasses--;

        this.txtGlasses.text = `g X ${this.gcount}`;
      }
      else {
        this.scoreState = null;
      }
    }
  }
}